import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'ct-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(toastsManager: ToastsManager, viewContainerRef: ViewContainerRef) {
        toastsManager.setRootViewContainerRef(viewContainerRef); // Set ViewContainerRef once for notifications
    }

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/app.component.ts